
interface AIQAPanelProps {
  organizationFilter?: string
  trackerFilter?: string
}

export function AIQAPanel({ organizationFilter, trackerFilter }: AIQAPanelProps) {
  return null
}
